<template>
    <div class="error-container">
      <!-- <div class="login-header">
        <div class="login"></div>
      </div> -->
      <el-form class="error-form gsForm" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="110px">
        <h3 class="title">{{$t("wm_lang_html_7fc88a")}}</h3>
        <h4 class="p20 texLine">{{changePwType}}</h4>
        <div class="el-error__body">
          <div class="el-error__bd float-l">
        <el-form-item :label="$i18n.t('wm_lang_cd043c')" prop="origPassword">
          <el-input type="password" v-model="ruleForm.origPassword" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_72d55e')" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('wm_lang_670d63')" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item class="pt20">
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
          <!--<el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_4b9c32")}}</el-button>-->
          <el-button type="primary" @click.native.prevent="goBack">{{$t("wm_lang_html_5f4112")}}</el-button>
          <!-- <el-button @click.native.prevent="goSkip" v-show='skipBtn'>{{$t("wm_lang_html_92636e")}}</el-button> -->
        </el-form-item>
        </div>

          <div class="note-box c_blue float-r" style="width:368px;">
            <p v-if="pwdWeakRule.pwdClassify">1.{{$t("wm_lang_html_a72631")}}{{pwdWeakRule.pwdClassifyCount}}{{$t("wm_lang_html_918be6")}}</p>
            <p v-if="pwdWeakRule.pwdLen">2.{{$t("wm_lang_html_773926")}}{{pwdWeakRule.minPwdLen}}{{$t("wm_lang_html_40ff1a")}}20{{$t("wm_lang_html_cf10dc")}}</p>
            <p v-if="pwdWeakRule.pwdDiffOriginal">3.{{$t("wm_lang_html_2161fa")}}</p>
            <p v-if="pwdWeakRule.pwdIncDomainUser">4.{{$t("wm_lang_html_390209")}}</p>
            <p v-if="pwdWeakRule.pwdWeakForbidden">5.{{$t("wm_lang_html_cc4637")}}12345678{{$t("wm_lang_html_11ccee")}}</p>
            <p v-if="pwdWeakRule.pwdDiscontinuity">6.{{$t("wm_lang_html_600565")}}</p>
          </div>
        </div>
      </el-form>

    </div>
</template>

<script>
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { rsaEncrypt } from '@/utils/utils';
    export default {
      components: { },
      name: 'ChangePw',
      data() {
        let checkOrigPassword = (rule, value, callback) => {
          if (value === '') {
            callback(new Error(this.$i18n.t('wm_lang_9c19a4')));
          } else {
            //
            callback();
          }
        };
        let validatePass = (rule, value, callback) => {
          if(value.indexOf(' ') !== -1) {
            callback(new Error(this.$i18n.t('wm_lang_7650a1')));
          }
          if(value === this.ruleForm.origPassword) {
            callback(new Error(this.$i18n.t('wm_lang_1bb474')));
          }
          if (value === '') {
            callback(new Error(this.$i18n.t('wm_lang_e39ffe')));
          } else {
            if (this.ruleForm.checkPass !== '') {
              this.$refs.ruleForm.validateField('checkPass');
            }
            let self = this;
            (function (api, enums, pms) {
              let pm = {password: rsaEncrypt(value)};
              api.UnActiveAccount.detectPassword(pm, function (res) {
                if(res.data.code === 0) {
                  if(!res.data.data.isAccordRule) {
                    callback(new Error(self.$i18n.t('wm_lang_62a7e4')));
                  } else {
                    callback();
                  }
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          }
        };
        let validatePass2 = (rule, value, callback) => {
          if(value.indexOf(' ') !== -1) {
            callback(new Error(this.$i18n.t('wm_lang_7650a1')));
          }
          if (value === '') {
            callback(new Error(this.$i18n.t('wm_lang_a24ab0')));
          } else if (value !== this.ruleForm.pass) {
            callback(new Error(this.$i18n.t('wm_lang_f0d640')+'!'));
          } else {
            callback();
          }
        };
        return {
          ruleForm: {
            pass: '',
            checkPass: '',
            origPassword: ''
          },
          rules: {
            pass: [
              { validator: validatePass, trigger: 'blur' }
            ],
            checkPass: [
              { validator: validatePass2, trigger: 'blur' }
            ],
            origPassword: [
              { validator: checkOrigPassword, trigger: 'blur' }
            ]
          },
          changePwType: '',
          pwdWeakRule: {},
          skipBtn: false
        };
      },
      computed: {
        //
      },
      methods: {
        goBack() {
          this.$router.push({ path: '/' });
        },
        goSkip() {
          this.$router.push({ path: '/' });
        },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let self = this;
              (function (api, enums, pms) {
                let pm = pms.UnActiveAccount.updatePasswordParamBuilder();
                pm.oldPassword = rsaEncrypt(self.ruleForm.origPassword);
                pm.newPassword =  rsaEncrypt(self.ruleForm.pass);
                api.UnActiveAccount.updatePassword(pm, function (res) {
                  console.log(res)
                  if(res.data.code === 0) {
                    self.$message({
                      type: 'success',
                      message: self.$i18n.t('wm_lang_33130f')+'!'
                    });
                    self.$router.push({ path: '/' });
                  } else {
                    //做多语言前暂时先用拦截器弹出后端错误提示
                    // let eMsg = self.$GetErrorMsg(res.data.code);
                    // self.$message({
                    //   type: 'error',
                    //   message: eMsg
                    // });
                  }
                })
              })(xmail.api, xmail.enums, xmail.pms);
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        }
      },
      mounted() {
        // console.log(this.$route.params);
        // this.errorData = this.$route.params.errorData;
        this.pwdWeakRule = storeLocal.get('Pwm-passwordRule');
        if(this.pwdWeakRule.pwType === xmail.enums.ErrorCode.WM_PASSWORD_WEAK_ERROR || xmail.enums.ErrorCode.UDR_USER_PASSWORD_WEAK_ERROR){
          this.changePwType = this.$i18n.t('wm_lang_27bf68');
          this.skipBtn = true
        }
        if(this.pwdWeakRule.pwType === xmail.enums.ErrorCode.UDR_USER_PASSWORD_FIRST_ERROR){
          this.changePwType = this.$i18n.t('wm_lang_2005d7');
        }
        if(this.pwdWeakRule.pwType === xmail.enums.ErrorCode.UDR_USER_PASSWORD_CYCLE_ERROR){
          this.changePwType = this.$i18n.t('wm_lang_439d6f');
        }

        //强制刷新多语言
        let configSetting = storeLocal.get('Pwm-configSetting');
        if(configSetting) {
          if(this.$route.params.errorData.data.webLanguage && this.$route.params.errorData.data.webLanguage !== configSetting.displaySetting.language) {
            configSetting.displaySetting.language = this.$route.params.errorData.data.webLanguage;
            storeLocal.set('Pwm-configSetting', configSetting);
            location.reload()
          }
        }
      },
      created() {
        //
      },
      destroyed() {
        //
      }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .error-container {
    position: relative;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    // background-color: #0661E4;
    .texLine{border-bottom: 1px solid #eee;}
  }
  .title {
      font-size: 16px;
      font-weight: 400;
      background: #3986ee;
      color: #fff;
      margin: 0 auto;
      text-align: left;
      padding: 12px 20px!important;
  }
  .error-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 840px;
    margin: 0 auto;
    margin-top: 20vh;
    box-shadow: 0px 8px 16px -8px rgba(0,0,0,0.16), 0px 12px 32px 0px rgba(0,0,0,0.12), 0px 16px 48px 16px rgba(0,0,0,0.08), 0px 8px 16px -8px rgba(0,0,0,0.16), 0px 12px 32px 0px rgba(0,0,0,0.12), 0px 16px 48px 16px rgba(0,0,0,0.08);border-radius: 0px!important;border:none!important;
    background:#fff;
  }
  .el-error__body{
    padding: 20px;
    overflow: hidden;
    .el-error__bd{width:380px;}
    .note-box{line-height:21px;padding-top:20px;}
    }
  .login-header{
      height:102px;
      width:90%;
      position:fixed;
      top:0;
      left:5%;
      .login{background-image: url('~@/assets/images/logo_pic.png');background-size:80%;background-repeat: no-repeat;height:73px;width:194px;margin-top:30px;}
  }

</style>



// WEBPACK FOOTER //
// src/components/views/login/changePw.vue